import { memo, useMemo } from "react";

import type { IStatisticsProps } from "./types";

import { BaseLoader } from "@components/molecules/baseLoader";
import { Swiper } from "@/components/atoms/swiper";
import { InfoCard } from "@/components/molecules/infoCard";

export const Statistics = memo(function Statistics(props: IStatisticsProps) {
  const itemsComponent = useMemo(
    () =>
      props.data.map((data) => (
        <InfoCard
          key={data?.key + data?.name + data?.value}
          value={data.value || 0}
          variant={data.key}
          title={data.name}
        />
      )),
    [props.data],
  );

  return (
    <BaseLoader
      type={"statistic-card"}
      isLoading={props?.isLoading}
      isError={props?.isError}
    >
      <Swiper>{itemsComponent}</Swiper>
    </BaseLoader>
  );
});
